import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';

import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

import Header from 'components/Header';
import { BoxBorder, LayoutWrap } from 'components/Base';
import { useLocales } from 'locales';

import { AdminManageList, ManageHead } from 'components/Part';
import BackToMainUser from "../components/BackToMainUser";

const AdminLayout = () => {
    const { t } = useLocales();

    const [title, setTitle] = useState<{ name: string, idx: number }>();
    return (
        <>
            <Helmet>
                <meta name="viewport" content="width=1000" />
            </Helmet>
            <Stack>
                <Header />
                <LayoutWrap>
                    <Container maxWidth='xl'>
                        <Stack direction='row' alignItems='center' justifyContent='space-between'>
                            <BackToMainUser />
                            <AdminManageList setTitle={setTitle} />
                            <a href="https://nonet">
                                <Button color='error' startIcon={<PowerSettingsNewIcon />}>{t("Back to site")}</Button>
                            </a>
                        </Stack>
                        <BoxBorder >
                            <ManageHead title={title?.name} idx={title?.idx} />
                            <Outlet />
                        </BoxBorder>
                    </Container>
                </LayoutWrap>
            </Stack>
        </>
    );
}
export default AdminLayout;
